module.exports = __webpack_public_path__ + "img/img6.8d8b8549.png";